import React from "react";
// import { Outlet } from "react-router-dom";

// page
import MessagePage from "../pages/message";

// eslint-disable-next-line
export default {
  path: "/message",
  element: <MessagePage />,
  errorElement: <p>error</p>,
  // children: [
  //   {
  //     path: "settingTable/:id",
  //     element: <SettingTable />,
  //   },
  // ],
};
